import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Star, BookOpen, ArrowRight, Gift, Sparkles, Download, Check } from 'lucide-react';
import { toast } from 'sonner';
import GiftModal from './GiftModal';
import { isPromoActive, PROMO } from '../data/promo-config';

const API = process.env.REACT_APP_BACKEND_URL;

// ─── NEW RELEASE (2026) ───
const NEW_BOOK_COVER = 'https://customer-assets.emergentagent.com/job_5d4ad1e7-aed7-4c2c-bd02-652824eb659e/artifacts/m0moy2po_FUCK_THATT_What_Do_I_Want_NOW_KDP_Ebook_Cover_1600x2560.png';
const NEW_BOOK_AMAZON = 'https://www.amazon.com/dp/B0GZN2ZZ5V';

// ─── ORIGINAL MEMOIR (2016 / 10-Year Anniversary Edition) ───
const MEMOIR_COVER = 'https://customer-assets.emergentagent.com/job_e81db766-430a-4b91-9c64-aad9677ac04c/artifacts/e8o0cz9t_Anniversary%20Cover%20to%20FTHATT%20orginal%20book%20.png';

// ─── COMPANION WORKBOOK (2026 · ebook PDF + EPUB) ───
const WORKBOOK_COVER = "https://customer-assets.emergentagent.com/job_e81db766-430a-4b91-9c64-aad9677ac04c/artifacts/m8yxfebu_The%20main%20ingredient%20Book%20Cover%20.png";
const WORKBOOK_BACK = "https://customer-assets.emergentagent.com/job_e81db766-430a-4b91-9c64-aad9677ac04c/artifacts/q77vmdoh_The%20back%20of%20The%20Main%20Ingredient.png";

// ─── HOW TO SAY F.U.C.K. T.H.A.T.T. AND TAKE YOUR LIFE BACK! (2026 · ebook PDF + EPUB) ───
const LIFEBACK_COVER = 'https://customer-assets.emergentagent.com/job_14cc4871-687e-4891-af0a-b689414d4eb3/artifacts/7fpqtp9t_the%20cover%20for%20How%20to%20say%20FTHATT%20in%20purple.png';

const AUTHOR_IMG_URL = 'https://customer-assets.emergentagent.com/job_988ca3c4-0353-4296-b3e4-3dfc4a85f5c2/artifacts/91jkfvp8_Cabrini%20with%20hand%20on%20chin.png';

const WHAT_INSIDE = [
  { title: 'The Three Questions That Change Everything', body: 'Who am I? What do I want? Why do I want it? — the prompts that begin every transformation.' },
  { title: 'The 5 Principles', body: 'Make a Decision · Trust Your Decision · Stay Focused · Take Inspired Action · Enjoy the Journey.' },
  { title: 'The 7-Day Reset', body: 'A guided week of decision, trust, focus, action, and reflection — the practical reset for women asking "Now what?"' },
  { title: 'Your NOW Life Declaration', body: 'The closing chapter where you put it all on paper. Who you are, what you want, why you want it, and what you will do about it.' },
];

const NEW_EXCERPTS = [
  { quote: "You are not ungrateful. You are awake.", chapter: "Chapter 1 — The Moment You Ask 'Now What?'" },
  { quote: "She got you here. Now she cannot take you there.", chapter: "Chapter 1" },
  { quote: "You are not lost. You are between identities.", chapter: "Chapter 1" },
  { quote: "I AM allowed to want something new.", chapter: "Chapter 1" },
];

const PATH_CONNECTIONS = [
  { chapter: 'Chapter 1 — Now What?', path: 'The Threshold' },
  { chapter: 'Chapters 2–4 — The Three Questions', path: 'Your Life-Map' },
  { chapter: 'Chapter 5 — Make a Decision', path: 'The Path to F.U.C.K. T.H.A.T.T.' },
  { chapter: 'Chapter 7 — Stay Focused', path: 'The F.E.A.R. Path' },
  { chapter: 'Chapter 9 — Enjoy the Journey', path: 'GangstaChef\'s Kitchen' },
  { chapter: 'Chapter 10 — NOW Life Declaration', path: 'The Fire Circle' },
];

export default function BookPage() {
  const [showWorkbookBack, setShowWorkbookBack] = useState(false);
  const [buyingWorkbook, setBuyingWorkbook] = useState(false);
  const [buyingMemoir, setBuyingMemoir] = useState(false);
  const [buyingNow, setBuyingNow] = useState(false);
  const [buyingLifeBack, setBuyingLifeBack] = useState(false);
  const [buyingBundle, setBuyingBundle] = useState(false);
  const [buyingDeck, setBuyingDeck] = useState(false);
  const [waitlistEmail, setWaitlistEmail] = useState('');
  const [waitlistStatus, setWaitlistStatus] = useState('idle');
  const promo = isPromoActive();

  async function buyWorkbook() {
    setBuyingWorkbook(true);
    try {
      const res = await fetch(`${API}/api/checkout`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          product_id: 'ebook-main-ingredient',
          origin_url: window.location.origin,
        }),
      });
      const data = await res.json();
      if (data.url) {
        window.location.href = data.url;
      } else {
        toast.error('Could not start checkout. Please try again.');
        setBuyingWorkbook(false);
      }
    } catch {
      toast.error('Something went wrong. Please try again.');
      setBuyingWorkbook(false);
    }
  }

  async function buyMemoir() {
    setBuyingMemoir(true);
    try {
      const res = await fetch(`${API}/api/checkout`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          product_id: 'ebook-memoir-anniversary',
          origin_url: window.location.origin,
        }),
      });
      const data = await res.json();
      if (data.url) {
        window.location.href = data.url;
      } else {
        toast.error('Could not start checkout. Please try again.');
        setBuyingMemoir(false);
      }
    } catch {
      toast.error('Something went wrong. Please try again.');
      setBuyingMemoir(false);
    }
  }

  async function buyProduct(productId, setLoading) {
    setLoading(true);
    try {
      const res = await fetch(`${API}/api/checkout`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ product_id: productId, origin_url: window.location.origin }),
      });
      const data = await res.json();
      if (data.url) {
        window.location.href = data.url;
      } else {
        toast.error('Could not start checkout. Please try again.');
        setLoading(false);
      }
    } catch {
      toast.error('Something went wrong. Please try again.');
      setLoading(false);
    }
  }

  async function notifyMe(e) {
    e.preventDefault();
    if (!waitlistEmail.trim()) return;
    setWaitlistStatus('loading');
    try {
      const res = await fetch(`${API}/api/email-capture`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: waitlistEmail.trim(), source: 'Store Waitlist' }),
      });
      if (!res.ok) throw new Error();
      setWaitlistStatus('success');
    } catch {
      toast.error('Something went wrong. Please try again.');
      setWaitlistStatus('idle');
    }
  }

  return (
    <section data-testid="book-page" className="book-page">
      {/* ════════════════════════════════════════════════
          MEMOIR HERO — Where It All Began (10-Year Edition)
          ════════════════════════════════════════════════ */}
      <div className="book-hero book-hero--memoir" data-testid="book-hero">
        <div className="book-hero-cover">
          <div className="book-cover-wrapper">
            <img
              alt="F.U.C.K. T.H.A.T.T. — What do you WANT? 10-Year Anniversary Edition by Cabrini Schnyder"
              className="book-cover-img"
              data-testid="book-cover-image"
              src={MEMOIR_COVER}
            />
          </div>
        </div>
        <div className="book-hero-text">
          <p className="book-label book-label--memoir">The Origin Story · Where It All Began</p>
          <h1 className="book-title" data-testid="book-title">
            F.U.C.K. T.H.A.T.T.<br />
            <span className="book-title-sub book-title-sub--turquoise">What do you WANT?</span>
          </h1>
          <p className="book-subtitle">
            An Entrepreneur&apos;s Journey to Self-Discovery — newly cleaned, beautifully formatted, available <strong>direct from Cabrini</strong>.
          </p>
          <p className="book-author">by Cabrini Schnyder · 2016 / 10-Year Edition</p>
          <div className="book-hero-meta">
            <div className="book-stars" data-testid="book-stars">
              {[...Array(5)].map((_, i) => (
                <Star key={i} size={16} fill="#40c5c8" stroke="#40c5c8" />
              ))}
            </div>
            <span className="book-edition">65 chapters · PDF + EPUB · not on Amazon</span>
          </div>
          <div className="book-hero-cta">
            <button
              type="button"
              onClick={buyMemoir}
              disabled={buyingMemoir}
              className="village-btn village-btn--primary book-hero-btn--memoir"
              data-testid="memoir-buy-btn"
            >
              {buyingMemoir ? (
                'Opening checkout…'
              ) : (
                <>
                  <Download size={18} strokeWidth={2.2} />
                  Buy &amp; Download · $19.99
                </>
              )}
            </button>
            <Link to="/gift" className="village-btn village-btn--secondary" data-testid="book-free-chapter-btn">
              <Gift size={18} />
              Read a Free Chapter
            </Link>
            <GiftModal
              productId="ebook-memoir-anniversary"
              productLabel="the Memoir"
              buttonLabel="Gift the Memoir"
              buttonClassName="village-btn village-btn--secondary"
              testId="memoir-gift-btn"
            />
          </div>
          <p className="book-hero-fineprint">
            Secure Stripe checkout · Audio narration in production for summer 2026.
          </p>
        </div>
      </div>

      {/* ════════════════════════════════════════════════
          MORE BOOKS IN THE LIBRARY
          ════════════════════════════════════════════════ */}
      <div className="book-library-row" data-testid="book-library-row">
        <div className="book-section-head">
          <p className="book-section-eyebrow">More From Cabrini&apos;s Library</p>
          <h2 className="book-section-title">Continue the Journey</h2>
        </div>

        <div className="book-library-grid">

          {/* ── How to Say F.U.C.K. T.H.A.T.T. And Take Your LIFE BACK! (Direct PDF + EPUB) ── */}
          <article className="book-lib-card book-lib-card--new" data-testid="book-lib-card-lifeback">
            <div className="book-lib-cover">
              <img src={LIFEBACK_COVER} alt="How to Say F.U.C.K. T.H.A.T.T. And Take Your LIFE BACK!" />
              <div className="book-lib-cover-badge">New 2026 · PDF + EPUB</div>
            </div>
            <div className="book-lib-body">
              <p className="book-lib-eyebrow">The Flagship Guide · 2026</p>
              <h3 className="book-lib-title">
                Take Your <em>LIFE BACK!</em>
              </h3>
              <p className="book-lib-sub">
                The full 25-chapter playbook for finally saying F.U.C.K. T.H.A.T.T. —
                make the decision, trust it, and walk into the life that&apos;s yours.
              </p>
              <p className="book-lib-meta">
                <Check size={13} strokeWidth={2.4} />
                <span>PDF + EPUB · 25 chapters · 227 pages · instant download</span>
              </p>
              <button
                type="button"
                onClick={() => buyProduct('ebook-life-back', setBuyingLifeBack)}
                disabled={buyingLifeBack}
                className="village-btn village-btn--primary book-lib-btn"
                data-testid="lifeback-buy-btn"
              >
                {buyingLifeBack ? (
                  'Opening checkout…'
                ) : (
                  <>
                    <Download size={16} />
                    Buy Direct · $19.99
                  </>
                )}
              </button>
              <GiftModal
                productId="ebook-life-back"
                productLabel="Take Your LIFE BACK!"
                buttonLabel="Gift it"
                buttonClassName="village-btn village-btn--secondary book-lib-btn"
                testId="lifeback-gift-btn"
              />
            </div>
          </article>

          {/* ── New Release (Direct PDF + EPUB) ── */}
          <article className="book-lib-card book-lib-card--new" data-testid="book-lib-card-new">
            <div className="book-lib-cover">
              <img src={NEW_BOOK_COVER} alt="F.U.C.K. T.H.A.T.T. What Do I Want NOW!" />
              <div className="book-lib-cover-badge">
                {promo ? `FREE · ${PROMO.shortLabel}` : 'New 2026 · PDF + EPUB'}
              </div>
            </div>
            <div className="book-lib-body">
              <p className="book-lib-eyebrow">Brand New · 2026</p>
              <h3 className="book-lib-title">
                What Do I Want <em>NOW!</em>
              </h3>
              <p className="book-lib-sub">
                Ditch the bullsh*t. Get crystal clear. Create a life that feels like freedom.
              </p>
              <p className="book-lib-meta">
                <Check size={13} strokeWidth={2.4} />
                <span>PDF + EPUB · 10 chapters + 7-Day Reset · instant download</span>
              </p>
              <button
                type="button"
                onClick={() => buyProduct('ebook-what-do-i-want-now', setBuyingNow)}
                disabled={buyingNow}
                className="village-btn village-btn--primary book-lib-btn"
                data-testid="newbook-buy-btn"
              >
                {buyingNow ? (
                  'Opening checkout…'
                ) : (
                  <>
                    <Download size={16} />
                    Buy Direct · $12.99
                  </>
                )}
              </button>
              <a
                href={NEW_BOOK_AMAZON}
                target="_blank"
                rel="noopener noreferrer"
                className="book-lib-altlink"
                data-testid="book-amazon-btn"
                style={{ display: 'inline-block', marginTop: '0.6rem', fontSize: '0.82rem', color: '#b8902b', textDecoration: 'underline', textUnderlineOffset: '3px' }}
              >
                or get it on Amazon →
              </a>
              <GiftModal
                productId="ebook-what-do-i-want-now"
                productLabel="What Do I Want NOW!"
                buttonLabel="Gift it"
                buttonClassName="village-btn village-btn--secondary book-lib-btn"
                testId="newbook-gift-btn"
              />
            </div>
          </article>

          {/* ── Workbook (Direct) ── */}
          <article className="book-lib-card book-lib-card--workbook" data-testid="book-lib-card-workbook">
            <div className="book-lib-cover">
              <img
                src={showWorkbookBack ? WORKBOOK_BACK : WORKBOOK_COVER}
                alt="The Main Ingredient Workbook"
              />
              <div className="book-lib-cover-badge book-lib-cover-badge--gold">
                Available Here First
              </div>
              <button
                type="button"
                className="book-lib-flip"
                onClick={() => setShowWorkbookBack((v) => !v)}
                data-testid="workbook-flip-btn"
                aria-label={showWorkbookBack ? 'Show front cover' : 'Show back cover'}
              >
                {showWorkbookBack ? 'Front' : 'Flip ↻'}
              </button>
            </div>
            <div className="book-lib-body">
              <p className="book-lib-eyebrow">The Companion Workbook</p>
              <h3 className="book-lib-title">
                The Main <em>Ingredient</em>
              </h3>
              <p className="book-lib-sub">
                50 funny, spiritual prompts &amp; journal pages to stop playing small and cook up the LIFE you actually WANT.
              </p>
              <p className="book-lib-meta">
                <Check size={13} strokeWidth={2.4} />
                <span>PDF + EPUB · 125 pages · instant download</span>
              </p>
              <button
                type="button"
                onClick={buyWorkbook}
                disabled={buyingWorkbook}
                className="village-btn village-btn--primary book-lib-btn"
                data-testid="workbook-buy-btn"
              >
                {buyingWorkbook ? (
                  'Opening checkout…'
                ) : (
                  <>
                    <Download size={16} />
                    Buy Direct · $9.99
                  </>
                )}
              </button>
              <GiftModal
                productId="ebook-main-ingredient"
                productLabel="the Workbook"
                buttonLabel="Gift it"
                buttonClassName="village-btn village-btn--secondary book-lib-btn"
                testId="workbook-gift-btn"
              />
            </div>
          </article>

        </div>

        <div className="book-bundle-banner" id="trilogy-bundle" data-testid="book-bundle-banner" style={{
          maxWidth: '760px', margin: '2.5rem auto 0', padding: '1.75rem 2rem',
          borderRadius: '18px', textAlign: 'center',
          background: 'linear-gradient(155deg, rgba(212,175,55,0.12), rgba(26,18,56,0.5))',
          border: '1px solid rgba(212,175,55,0.4)',
        }}>
          <p style={{ fontSize: '0.72rem', letterSpacing: '0.2em', textTransform: 'uppercase', color: '#d4af37', marginBottom: '0.5rem' }}>
            Best Value · All 3 Books
          </p>
          <h3 style={{ fontSize: '1.6rem', color: '#f8e7b0', margin: '0 0 0.5rem' }}>
            The Trilogy of Truth
          </h3>
          <p style={{ color: 'rgba(245,236,215,0.85)', marginBottom: '1.1rem', lineHeight: 1.6 }}>
            The Memoir, <em>What Do I Want NOW!</em>, and the Workbook — all in
            PDF + EPUB, delivered together.{' '}
            <strong style={{ color: '#fff' }}>$29.99</strong>{' '}
            <span style={{ textDecoration: 'line-through', color: 'rgba(245,236,215,0.5)' }}>$42.97</span>
          </p>
          <button
            type="button"
            onClick={() => buyProduct('bundle-trilogy', setBuyingBundle)}
            disabled={buyingBundle}
            className="village-btn village-btn--primary"
            data-testid="bundle-buy-btn"
          >
            {buyingBundle ? 'Opening checkout…' : (<><Download size={16} /> Get All 3 · $29.99</>)}
          </button>
          <div style={{ marginTop: '0.75rem' }}>
            <GiftModal
              productId="bundle-trilogy"
              productLabel="the Trilogy"
              buttonLabel="Gift the Trilogy"
              buttonClassName="village-btn village-btn--secondary"
              testId="bundle-gift-btn"
            />
          </div>
        </div>
      </div>

      {/* ════════════════════════════════════════════════
          THE CARDS — Digital Deck + free Pull a Card
          ════════════════════════════════════════════════ */}
      <div className="book-library-row" data-testid="book-cards-section">
        <div className="book-section-head">
          <p className="book-section-eyebrow">Tarot-Style Inspiration · 50 Cards</p>
          <h2 className="book-section-title">The F.U.C.K. T.H.A.T.T. Cards</h2>
          <p className="book-section-subtitle">
            50 bold-truth cards with a Cabrini Check-In on the back. Pull one free
            every day, or take the whole deck home.
          </p>
        </div>

        <div
          data-testid="book-deck-card"
          style={{
            maxWidth: '860px',
            margin: '0 auto',
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            gap: '2rem',
            padding: '2rem',
            borderRadius: '18px',
            background: 'linear-gradient(155deg, rgba(212,175,55,0.1), rgba(26,18,56,0.5))',
            border: '1px solid rgba(212,175,55,0.35)',
          }}
        >
          <img
            src="/cards/box_front.webp"
            alt="The F.U.C.K. T.H.A.T.T. Card Deck"
            loading="lazy"
            style={{ flex: '0 0 200px', width: '200px', borderRadius: '12px', boxShadow: '0 16px 40px rgba(0,0,0,0.5)', border: '1px solid rgba(212,175,55,0.35)', margin: '0 auto' }}
          />
          <div style={{ flex: '1 1 320px' }}>
            <p style={{ fontSize: '0.72rem', letterSpacing: '0.2em', textTransform: 'uppercase', color: '#d4af37', marginBottom: '0.4rem' }}>
              Digital Deck · Instant PDF
            </p>
            <p style={{ color: 'rgba(245,236,215,0.88)', lineHeight: 1.6, marginBottom: '1rem' }}>
              All 50 cards as a print-ready PDF — pull one each morning on your
              phone or print your own ritual deck. <strong style={{ color: '#fff' }}>$14.99</strong>
            </p>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.6rem' }}>
              <Link to="/pull-a-card" className="village-btn village-btn--secondary" data-testid="book-pull-card-btn">
                <Sparkles size={16} /> Pull a Free Card
              </Link>
              <button
                type="button"
                onClick={() => buyProduct('digital-card-deck', setBuyingDeck)}
                disabled={buyingDeck}
                className="village-btn village-btn--primary"
                data-testid="book-deck-buy-btn"
              >
                {buyingDeck ? 'Opening checkout…' : (<><Download size={16} /> Buy Deck · $14.99</>)}
              </button>
              <GiftModal
                productId="digital-card-deck"
                productLabel="the Digital Deck"
                buttonLabel="Gift it"
                buttonClassName="village-btn village-btn--secondary"
                testId="book-deck-gift-btn"
              />
            </div>
            <p style={{ marginTop: '0.9rem', fontSize: '0.85rem', color: '#d4af37' }}>
              🎁 Physical boxed deck ($29.99) coming soon —{' '}
              <a
                href="#book-store"
                onClick={(e) => { e.preventDefault(); document.getElementById('book-store')?.scrollIntoView({ behavior: 'smooth', block: 'center' }); }}
                style={{ color: '#f8e7b0', textDecoration: 'underline' }}
                data-testid="book-deck-waitlist-link"
              >
                join the waitlist
              </a>.
            </p>
            <p
              data-testid="deck-bundle-nudge"
              style={{ marginTop: '0.5rem', fontSize: '0.85rem', color: 'rgba(245,236,215,0.8)' }}
            >
              ✦ Complete your collection —{' '}
              <a
                href="#trilogy-bundle"
                onClick={(e) => { e.preventDefault(); document.getElementById('trilogy-bundle')?.scrollIntoView({ behavior: 'smooth', block: 'center' }); }}
                style={{ color: '#f8e7b0', textDecoration: 'underline' }}
                data-testid="deck-bundle-nudge-link"
              >
                add the Trilogy of Truth
              </a>{' '}(all 3 books, $29.99) and save $13.
            </p>
          </div>
        </div>
      </div>

      {/* ════════════════════════════════════════════════
          THE VILLAGE STORE — Physical goods (waitlist)
          ════════════════════════════════════════════════ */}
      <div className="book-library-row" id="book-store" data-testid="book-store-section">
        <div className="book-section-head">
          <p className="book-section-eyebrow">The Village Store · Physical Goods</p>
          <h2 className="book-section-title">Coming Soon to My Book Collection</h2>
          <p className="book-section-subtitle">
            The boxed card deck, tees, hoodies, journals &amp; mugs — designed with
            sacred intention. Join the waitlist and be first when doors open. 🌙
          </p>
        </div>

        <div
          style={{
            maxWidth: '560px',
            margin: '0 auto',
            padding: '1.75rem',
            borderRadius: '16px',
            textAlign: 'center',
            background: 'linear-gradient(155deg, rgba(212,175,55,0.1), rgba(26,18,56,0.5))',
            border: '1px solid rgba(212,175,55,0.35)',
          }}
        >
          {waitlistStatus === 'success' ? (
            <div data-testid="book-store-waitlist-success" style={{ color: '#7CFC9A', fontWeight: 600, display: 'inline-flex', alignItems: 'center', gap: '0.5rem' }}>
              <Check size={16} strokeWidth={2.4} />
              <span>You&apos;re on the list — we&apos;ll whisper when doors open.</span>
            </div>
          ) : (
            <form onSubmit={notifyMe} data-testid="book-store-waitlist-form" style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem', justifyContent: 'center' }}>
              <input
                type="email"
                required
                value={waitlistEmail}
                onChange={(e) => setWaitlistEmail(e.target.value)}
                placeholder="your@email.com"
                aria-label="Email for store waitlist"
                data-testid="book-store-waitlist-input"
                disabled={waitlistStatus === 'loading'}
                style={{
                  flex: '1 1 240px',
                  padding: '0.75rem 1rem',
                  borderRadius: '10px',
                  border: '1px solid rgba(212,175,55,0.4)',
                  background: 'rgba(0,0,0,0.3)',
                  color: '#f5ecd7',
                  fontSize: '0.9rem',
                }}
              />
              <button
                type="submit"
                className="village-btn village-btn--primary"
                data-testid="book-store-waitlist-submit"
                disabled={waitlistStatus === 'loading' || !waitlistEmail.trim()}
              >
                {waitlistStatus === 'loading' ? 'Joining…' : 'Notify Me'}
              </button>
            </form>
          )}
        </div>
      </div>

      {/* ── WHAT'S INSIDE (refers to the new release) ── */}
      <div className="book-inside-section" data-testid="book-inside-section">
        <div className="book-section-head">
          <p className="book-section-eyebrow">Inside · What Do I Want NOW!</p>
          <h2 className="book-section-title">The Book That Walks You Through &quot;Now What?&quot;</h2>
          <p className="book-section-subtitle">
            The 2026 release is a guided reset for women who are done sleep-walking through life.
          </p>
        </div>
        <div className="book-inside-grid">
          {WHAT_INSIDE.map((item, i) => (
            <div className="book-inside-card" data-testid={`book-inside-card-${i}`} key={i}>
              <h3 className="book-inside-card-title">{item.title}</h3>
              <p className="book-inside-card-body">{item.body}</p>
            </div>
          ))}
        </div>
      </div>

      {/* ── PATH CONNECTIONS (NEW BOOK → VILLAGE) ── */}
      <div className="book-paths-section" data-testid="book-paths-section">
        <h2 className="book-section-title">From the Book to the Village</h2>
        <p className="book-section-subtitle">Every chapter has a place to walk it out</p>
        <div className="book-paths-grid">
          {PATH_CONNECTIONS.map((item, i) => (
            <div className="book-path-card" data-testid={`book-path-card-${i}`} key={i}>
              <div className="book-path-header">
                <div className="book-path-from">
                  <span className="book-path-label">From the Book</span>
                  <span className="book-path-theme">{item.chapter}</span>
                </div>
                <ArrowRight size={18} className="book-path-arrow" />
                <div className="book-path-to">
                  <span className="book-path-label">In the Village</span>
                  <span className="book-path-name">{item.path}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* ── EXCERPTS ── */}
      <div className="book-excerpts-section" data-testid="book-excerpts-section">
        <h2 className="book-section-title">Lines That Will Stop You Mid-Read</h2>
        <p className="book-section-subtitle">A few moments from the new book</p>
        <div className="book-excerpts-grid">
          {NEW_EXCERPTS.map((item, i) => (
            <blockquote className="book-excerpt" data-testid={`book-excerpt-${i}`} key={i}>
              <p className="book-excerpt-quote">&quot;{item.quote}&quot;</p>
              <cite className="book-excerpt-chapter">— {item.chapter}</cite>
            </blockquote>
          ))}
        </div>
        <div className="book-excerpts-cta">
          <Link to="/gift" className="village-btn village-btn--secondary" data-testid="book-excerpts-gift-btn">
            <Gift size={16} /> Read the Whole First Chapter Free
          </Link>
        </div>
      </div>

      {/* ── AUTHOR ── */}
      <div className="book-author-section" data-testid="book-author-section">
        <div className="book-author-inner">
          <img alt="Cabrini Schnyder" className="book-author-img" src={AUTHOR_IMG_URL} />
          <div className="book-author-text">
            <h2 className="book-section-title">About the Author</h2>
            <p>Cabrini Schnyder is a lifelong DNA-Entrepreneur, author, speaker, music producer, life coach, and the creator of <strong>Cabrini&apos;s Law of F.U.C.K. T.H.A.T.T.</strong></p>
            <p>After decades of building businesses, facing adversity head-on, and transforming her own life, she created The Alchemy Village — a digital sanctuary for people ready to close the gap in their soul and create a life that actually matters.</p>
            <Link to="/about" className="book-author-link" data-testid="book-about-link">
              Read Cabrini&apos;s Full Story <ArrowRight size={14} />
            </Link>
          </div>
        </div>
      </div>

      {/* ── GANGSTA AI CTA removed — page temporarily down ── */}

      {/* ── FINAL CTA ── */}
      <div className="book-cta-section" data-testid="book-cta-section">
        <h2 className="book-cta-title">The book is the spark.<br />The Village is where you walk it out.</h2>
        <div className="book-cta-buttons">
          <Link to="/quiz" className="village-btn village-btn--primary" data-testid="book-cta-quiz">
            Discover Your Archetype
          </Link>
          <Link to="/life-map" className="village-btn village-btn--secondary" data-testid="book-cta-map">
            Explore the Village
          </Link>
        </div>
      </div>
    </section>
  );
}
